<div class="overlay view-note-log">
    <div class="overlay-header">
        <h2>View Notelog</h2>

        <div class="close-btn">
            <button mat-icon-button (click)="modalClose()">
                <f-icon icon-config='{"iconName": "xmark", "iconType": "light", "iconSize": "s"}'></f-icon>
            </button>
        </div>
    </div>
    <div class="section-divider"></div>
     <app-loader *ngIf="noteLogLoader" [loaderType]="rootScope.loaderTypeCard" [loaderMsg]="showLoaderMsg"></app-loader>
    <div class="container" *ngIf="!noteLogLoader">
        <div class="row">
   
            <div class="col-md-12">
                        <f-alert variant="warning" *ngIf="notelogErrorType === 'noData'">
                        {{notelogError}}
                    </f-alert>
                        <f-alert variant="error" *ngIf="notelogErrorType === 'apiError'"><p>{{ notelogError }}
                            <button class="btn-alert" (click)="openNoteLogDialog()">Try again</button></p>
                        </f-alert>
                        
                    <f-alert variant="success" *ngIf="saveSuccessMsg">{{saveSuccessMsg}}</f-alert>
                    <f-alert variant="error" *ngIf="saveErrorMsg">{{saveErrorMsg}}</f-alert>
                    <div class="comments">
                        <label class="form-label">Previous Entries</label>
                        <textarea [value]="notelogContent"
                            [readonly]="true"></textarea>

                    </div>
            </div>
        </div>
        <form [formGroup]="noteLogForm" (ngSubmit)="onSaveNoteLog()">
          <div class="row">
              <div class="col-md-12">
                  <f-textarea label-text="New Entry" formControlName="newEntry"></f-textarea>
              </div>
          </div>
          <div class="row">
              <div class="button-controls">
                  <f-button text="Cancel" title="Cancel" variant="action" (buttonClicked)="modalClose()"></f-button>
                  <f-button text="Save" title="Save" type="submit" variant="progressive" [disabled]="noteLogForm.invalid || noteLogForm.get('newEntry')?.value?.trim()?.length === 0"></f-button>
              </div>
          </div>
          
        </form>


    </div>


</div>